import { TInitialResponse, TSpinResponse } from "@src/server/ResponseTypes";
import { IGameServerConnector } from "@src/server/IGameServerConnector";
import { SingleInstanceClass } from "@src/core/utils/SingleInstanceClass";
import { gameEngine } from "@src/game/GameEngine";

export class Connector
  extends SingleInstanceClass
  implements IGameServerConnector {
  private _gameId: string;
  private _playerId: string;
  private _baseUrl: string;
  private _isDevelopmentEnvironment!: boolean;

  public constructor() {
    super();

    const params = new URLSearchParams(window.location.search);
    const gameId = params.get("gameId") || "treasure"; // Default value if not provided
    const playerId = params.get("playerId") || "player1"; // Default value if not provided

    if (!gameId || !playerId) {
      throw new Error("Missing gameId or playerId in URL");
    }

    this._gameId = gameId;
    this._playerId = playerId;
    this._isDevelopmentEnvironment = process.env.NODE_ENV === "development";

    this._baseUrl = "https://slot-backend-190897502095.us-central1.run.app";
    // this._isDevelopmentEnvironment
    //      ? "http://localhost:3000"
    //      : "https://slot-backend-190897502095.us-central1.run.app";
  }

  public async requestInitialGameData(): Promise<TInitialResponse> {
    try {
      const response = await fetch(`${this._baseUrl}/init`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          gameId: this._gameId,
          playerId: this._playerId,
        }),
      });

      if (!response.ok) throw new Error(await response.text());

      const data: TInitialResponse = await response.json();

      return data;
    } catch (error) {
      throw new Error(`Failed to fetch initial state: ${error}`);
    }
  }

  // Data coming from spins/cascades etc.
  public async requestGameActionData(rig?: string): Promise<TSpinResponse> {
    try {
      const response = await fetch(`${this._baseUrl}/spin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          gameId: this._gameId,
          playerId: this._playerId,
          bet: gameEngine.bet,
          rig,
        }),
      });

      if (!response.ok) throw new Error(await response.text());

      const data: TSpinResponse = await response.json();

      return data;
    } catch (error) {
      throw new Error(`Failed to perform game action: ${error}`);
    }
  }
}
